import React from 'react'
import moment from 'moment'

import {inWords, removeZeros} from '../../../utils/misc'
import {getUserSettings} from '../../../storage'


const TableCustomPadding = () =>(
  <style>
{".preview-a4 .table>tbody>tr>td { padding: 8px;}"}
  </style>
)

export default class TemplateGeneral extends React.Component {


  render() {
    let cn = this.props.credit
    let cp = this.props.company

    let settings = getUserSettings()

    let brandRow = <small><i>Generated with https://www.goodsbill.com</i></small>
    let cn_date = moment(cn.date).format('D-MM-YYYY')
    let billto_1, billto_2, billFrom
    let place_of_supply
    let shipping_address
    let optionalRow = false
    let table_cols = 2
    let credit_label = "CREDIT NOTE"
    let show_mrp_column = false
    let show_container_unit = false


    let bankDetails, declartion, tnc
    let credit_serial_prefix, serial
    if(typeof settings !== "undefined" && settings !== null) {
      credit_label= settings.credit_label
      credit_serial_prefix = settings.credit_serial_prefix
    }


    let header =<div className="text-center">
      <div className="company-name text-center text-uppercase" style={{fontSize:'130%', fontWeight:400, fontFamily:"serif"}}>
                      {cp.company_name}
                    </div>
        <div>
          {cp.address}
        </div>
        <div>{cp.city} {cp.state}</div>
        <div>GSTIN: {cp.gstin} State Code: {cp.state_code}</div>

    </div>


    if(typeof cn.client !== "undefined" && cn.client !== null) {

      place_of_supply = cn.client.city
      let client_gstin
      let client_phone
      if(typeof cn.client.gstin !== "undefined" && cn.client.gstin !== null && cn.client.gstin.length > 0) {
        client_gstin = "GSTIN-"+cn.client.gstin
      }
      if(typeof cn.client.phone !== "undefined" && cn.client.phone !== null && cn.client.phone.length > 0) {
        client_phone = "Ph: " + cn.client.phone
      }
      if(!cn.client.same_as_biiling) {
        shipping_address = <div>  <div className="gray">
                <strong>{cn.client.name}</strong>
          </div>
          <div className="gray">
              {cn.client.shipping_address}
          </div>
          <div className="gray">
          <span className="gray">
          {cn.client.shipping_city}
          </span>
          <span className="gray">
          {" "+cn.client.shipping_state} {" "+cn.client.shipping_pin}
          </span>
          <span className="gray">
          {cn.client.shipping_state_code.length > 0 ? " State Code: "+cn.client.shipping_state_code: ""}
          </span>

          </div>
          <div className="gray">
              {cn.client.shipping_state}-{cn.client.shipping_pin}
          </div></div>
      }
      else {
        shipping_address = <div>  <div className="gray">
                <strong>{cn.client.name}</strong>
          </div>
          <div className="gray">
              {cn.client.address}
          </div>
          <div className="gray">
            <span className="gray">
            {cn.client.city}
            </span>
            <span className="gray">
            {" "+cn.client.state} {" "+cn.client.pin}
            </span>
          <span className="gray">
          {cn.client.state_code.length > 0 ? " State Code: "+cn.client.state_code: ""}
          </span>

          </div>
          </div>
      }


      billto_1 =  <div className="row"><div className="col-xs-12">
        <div className="">
        <strong>To</strong>
          <div className="gray">
              <strong>{cn.client.name}</strong>
          </div>
          <div className="gray">
              {cn.client.address}
          </div>
          <div>
            <span className="gray">
           {cn.client.city} {" "+cn.client.state}
            </span>
            <span className="gray">
            {" "+cn.client.pin}
            </span>
            <span className="gray">
            {cn.client.state_code.length > 0 ? " State Code: "+cn.client.state_code: ""}
            </span>
          </div>
          <div>
          </div>
          <div className="gray">
             {client_gstin}
          </div>
        </div>
      </div></div>

    }





    return <div className="preview-a4" style={{fontFamily: "serif"}}>
      <TableCustomPadding />
              {header}
              <table className="table table-bordered">
                <tbody>
                  <tr><td colSpan={table_cols}>
                      <div className="text-center" style={{fontSize:'120%'}}>
                        {credit_label}
                      </div>

                      <div className="row">
                        <div className="col-xs-8">
                          {billto_1}
                        </div>
                        <div className="col-xs-4 text-right">
                          <div>CN No: {credit_serial_prefix}{cn.serial}</div>
                          <div>CN Date: {cn_date}</div>
                        </div>
                      </div>

                  </td></tr>

                <tr className="text-center">
                    <th className="text-center">Particulars</th>
                    <th className="text-center">Amount</th>
                  </tr>
                <tr>
                  <td className="text-center">{cn.notes}
                  </td>
                  <td className="text-center">
                    {cn.totalPrice}
                  </td>
                </tr>
                <tr>
                  <td className="text-right">TOTAL</td>
                  <td className="text-center">{cn.totalPrice}</td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    {inWords(cn.totalPrice)}
                  </td>
                </tr>
                <tr>

                  <td colSpan={2}>
                    <div className="row ">
                        <div className="col-xs-8">
                          <div className="space-large-bottom">
                            &nbsp;
                          </div>
                          <div>Receiver's Signature</div>
                        </div>
                        <div className="col-xs-4">
                          <div className="space-large-bottom">
                            For {cp.company_name}
                          </div>
                          <div>Authorized Signature</div>
                        </div>
                    </div>
                  </td>

                </tr>
                </tbody>



              </table>
      </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/generalnote/templates/templategeneral.js